import { CheckCircle2 } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const PENDING_ID_CHECKOUT_KEY = 'alu_pending_id_checkout';

const resolveLabel = (paymentFor) => {
  if (paymentFor === 'id_card_request') return 'ID Card Request';
  if (paymentFor === 'venue_booking') return 'Venue Booking';
  return 'Payment';
};

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const paymentFor = String(searchParams.get('paymentFor') || '').toLowerCase();
  const referenceId = searchParams.get('referenceId');
  const sessionId = searchParams.get('session_id');
  const label = resolveLabel(paymentFor);

  useEffect(() => {
    try {
      sessionStorage.removeItem(PENDING_ID_CHECKOUT_KEY);
    } catch {
      // Ignore storage access errors.
    }
  }, []);

  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem', background: '#f8fafc' }}>
      <section style={{ width: '100%', maxWidth: 680, background: '#fff', borderRadius: 16, padding: '2rem', boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#047857', marginBottom: '1rem' }}>
          <CheckCircle2 size={28} />
          <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Payment Successful</h1>
        </div>

        <p style={{ marginTop: 0, color: '#334155' }}>
          Your {label.toLowerCase()} payment was received. We will finalize your request shortly.
        </p>

        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: '0.875rem 1rem', marginBottom: '1.25rem' }}>
          {referenceId ? <p style={{ margin: '0 0 0.4rem 0', color: '#0f172a' }}><strong>Reference ID:</strong> {referenceId}</p> : null}
          {sessionId ? <p style={{ margin: 0, color: '#475569', wordBreak: 'break-all' }}><strong>Stripe Session:</strong> {sessionId}</p> : null}
        </div>

        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <Link to="/dashboard" style={{ background: '#0f172a', color: '#fff', textDecoration: 'none', padding: '0.65rem 1rem', borderRadius: 10, fontWeight: 600 }}>
            Go to Dashboard
          </Link>
          <Link
            to={paymentFor === 'venue_booking' ? '/my-venue-bookings' : '/digital-id'}
            style={{ background: '#fff', color: '#0f172a', textDecoration: 'none', padding: '0.65rem 1rem', borderRadius: 10, fontWeight: 600, border: '1px solid #cbd5e1' }}
          >
            View {label}
          </Link>
        </div>
      </section>
    </main>
  );
}
